import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Inline = styled.div`
  display: flex;

  * + * {
    margin-left: -${rem(8)};
  }
`

export default function InlineUserAvatars({ children }: PropsWithChildren<{}>) {
  return <Inline>{children}</Inline>
}
